export default __webpack_public_path__ + "static/media/vodafonecash_opay.b7ae23bb.png";